import { API_ROOT } from './configApi';

export default {
    // FA Annual Vac Bids
    saveYearlyBids() {
        return API_ROOT + 'api/faannualvacbids/save-yearly-bids';
    },

    // FA Control Record
    getYearlyControlRecordInfo(year) {
        return API_ROOT + 'api/vacationcontrol/yearly/' + year;
    },

    // FA Master Flight Admin
    getEmployeeInfo(employeeNumber, biddingYear) {
        return API_ROOT + 'api/famasterflightadmin/getemployeeinfoforyearly/' + employeeNumber + '/' + biddingYear;
    },

    // Fac Vac Awards
    getAwards(employeeNumber, biddingYear) {
        return API_ROOT + 'api/favacawards/employee/' + employeeNumber + '/' + biddingYear;
    },
    getAllAwards(employeeNumber, biddingYear) {
        return API_ROOT + 'api/favacawards/domicile/' + employeeNumber + '/' + biddingYear;
    },

    // Fa Available slots
    getAvailableSlots(employeeNumber, biddingYear) {
        return API_ROOT + 'api/faavailableslots/getslots/' + employeeNumber + '/' + biddingYear;
    }

};